import { Routes } from '@common/constants';

type BookableRestaurant = {
  providerId: string;
  configName: string;
  restaurantName: string;
};

export const bookingPath = (segment: string) =>
  Routes.TABLES_BOOK_RESTAURANT.replace('[restaurant]', encodeURIComponent(segment));

export const restaurantBookingSegment = (restaurant: BookableRestaurant) =>
  restaurant.configName || restaurant.restaurantName;

export function findBookingRestaurant<T extends BookableRestaurant>(
  restaurants: T[],
  segment: string | undefined
): T | null {
  if (!segment) return null;

  return (
    restaurants.find((restaurant) => restaurant.configName === segment) ??
    restaurants.find((restaurant) => restaurant.restaurantName === segment) ??
    restaurants.find((restaurant) => restaurant.providerId === segment) ??
    null
  );
}

type BookedRestaurantIds = {
  restaurantName?: unknown;
  restaurant?: unknown;
  restaurantConfig?: unknown;
};

const asSegment = (value: unknown) =>
  (typeof value === 'string' && value) || (typeof value === 'number' ? String(value) : undefined);

export const bookedRestaurantSegment = (ids: BookedRestaurantIds | null | undefined) =>
  asSegment(ids?.restaurantName) ?? asSegment(ids?.restaurant) ?? asSegment(ids?.restaurantConfig);
